<template>
  <q-card :flat="flat" :bordered="bordered" style="height: 100%; overflow: auto;">
    <!--Title-->
    <q-card-section class="q-py-none" :class="{ 'q-px-none': $slots.menu }" v-if="title">
      <div class="row items-center no-wrap q-py-sm">
        <div class="col">
          <div class="q-px-md title">{{ title }}</div>
        </div>
        <div class="col-auto">
          <slot name="menu" />
        </div>
      </div>
    </q-card-section>

    <q-card-section>
      <div :class="{ 'q-pa-none': noPadding }">
        <slot />
      </div>
    </q-card-section>
  </q-card>
</template>

<script>
export default {
  name: 'Panel',
  props: {
    title: {
      type: String,
    },
    flat: {
      type: Boolean,
      default: false,
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    noPadding: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 16px;
}
</style>
